import React, { useCallback } from 'react';
import { cx } from '@emotion/css';
import SyntaxColoringService from '../../../services/SyntaxColoringService';
function SyntaxColoringContainer({ className, id, value, encoder, }) {
    const htmlEncoder = useCallback((val) => new SyntaxColoringService(encoder).encodeHtml(val), [encoder]);
    const html = htmlEncoder(value);
    return (React.createElement("span", { className: cx('neo-syntax-coloring', className), id: id, dangerouslySetInnerHTML: { __html: html } }));
}
export default SyntaxColoringContainer;
//# sourceMappingURL=SyntaxColoringContainer.js.map